import { get } from "lodash";
import { useSelector } from "react-redux";

function useMainOrganization() {
  const authStore = useSelector(state => state.auth.organizations);
  const mainOrganization = get(
    authStore.filter(organization => organization.is_main === 1),
    "0"
  );

  return mainOrganization;
}

export default useMainOrganization;
